'use strict';
define([], function () {
    var gaugeCounter = 0;
    var ARC_LENGTH = 386.4;

    function controller() {
        var ctrl = this;
        ctrl.$onInit = function () {
            /* id univoco per il gradiente SVG: più gauge possono convivere nella pagina. */
            gaugeCounter++;
            ctrl.gradId = 'st-score-gauge-grad-' + gaugeCounter;
            normalizeGauge();
        };

        ctrl.$onChanges = normalizeGauge;

        function normalizeGauge() {
            var size = Number(ctrl.size);
            var score = Number(ctrl.score);
            ctrl.normalizedSize = isFinite(size) && size > 0
                ? Math.max(96, Math.min(320, size))
                : 150;
            ctrl.hasScore = ctrl.score !== null &&
                ctrl.score !== undefined &&
                ctrl.score !== '' &&
                isFinite(score);
            ctrl.normalizedScore = ctrl.hasScore
                ? Math.max(0, Math.min(100, score))
                : 0;
            ctrl.effectiveLoading = !!ctrl.loading || !ctrl.hasScore;
            ctrl.dashOffset = ARC_LENGTH * (1 - ctrl.normalizedScore / 100);
        };
    }

    return {
        templateUrl: 'app/modules/project/components/st-score-gauge/st-score-gauge.html',
        bindings: {
            score: '<',
            label: '<',
            size: '<',
            loading: '<',
            inverse: '<'
        },
        controller: controller
    };
});
